import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=934d54da&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934d54da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('934d54da')) {
      api.createRecord('934d54da', component.options)
    } else {
      api.reload('934d54da', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=934d54da&scoped=true&", function () {
      api.rerender('934d54da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MoLBS243NdfA/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports